var symphony = symphony || {};

;
symphony.freeTextArea = {

    init: function ($container) {
        $container = $container || $(window);

        // Add styles to parent tag for Money symbol.
        var moneyList = $('.u-money');

        if (moneyList.length > 0) {
            moneyList.each(function (index, m) {
                if ($(m).parent().hasClass("u-clear-after")) {
                    return;
                } else {
                    $(m).parent().addClass("u-clear-after");
                }
            });
        }

        this.parallaxInit($container);
    },

    parallaxInit: function ($container) {
        if ($('.freeTextArea.u-parallax').length > 0) {
            $container.scroll(function () {
                symphony.freeTextArea.parallax($container);
            });
            $(window).resize(function () {
                symphony.freeTextArea.parallax($container);
            });
            // inital load
            symphony.freeTextArea.parallax($container);
        }
    },

    parallax: function ($container) {
        $('.freeTextArea.u-parallax').each(function (i, elm) {
            var ftaTop = $(elm).offset().top;
            var ftaHeight = $(elm).outerHeight();
            var scrollPosition = window.scrollY || $(document).scrollTop();
            var windowHeight = $container.height();
            var animationStart = ftaTop - windowHeight;
            var animationStop = ftaTop + ftaHeight;

            if (scrollPosition >= animationStart && scrollPosition <= animationStop) {
                var scrollConstant = -400;
                var percentTravelled = (ftaTop + ftaHeight - scrollPosition) / (windowHeight + (ftaHeight * .75));
                var distanceTravelled = scrollConstant * percentTravelled;
                $(elm).find('.parallax-image').css('top', (distanceTravelled < scrollConstant ? scrollConstant : distanceTravelled) + 'px');
            }
        });
    }
};
